import { Link, NavLink, Outlet } from 'react-router-dom';

import { RingaLogo } from '../../brand/RingaLogo';
import { Scramble } from '../../brand/Scramble';
import { logout } from '../../lib/auth';

export const AdminLayout = ({ email }: { email: string }) => (
  <div className="admin">
    <header className="anav">
      <div className="anav-in">
        <Link to="/admin" className="anav-brand" aria-label="Metron, visão geral">
          <RingaLogo className="anav-logo" />
          <span className="anav-product">Metron</span>
        </Link>
        <nav aria-label="Administração" className="anav-links">
          <NavLink to="/admin" end>
            Visão geral
          </NavLink>
          <NavLink to="/admin/propostas" end>
            Propostas
          </NavLink>
        </nav>
        <div className="anav-right">
          <Link to="/admin/propostas/nova" className="btn btn-sm">
            <Scramble>Nova proposta</Scramble>
          </Link>
          <span className="anav-me" title={email}>
            {email}
          </span>
          <button type="button" className="btn btn-ghost btn-sm" onClick={logout}>
            Sair
          </button>
        </div>
      </div>
    </header>
    <main className="apage">
      <Outlet />
    </main>
  </div>
);
